export const DEFAULT_PATH_EMISSIONS = "/emissions/v2";
export const DEFAULT_PATH_CONSUMPTION = "/consumptions/v2";
export const DEFAULT_PATH_FINANCIALS = "/financials/v2";
export const DATA_READINESS_URL = "/approvals/v3";
export const TARGETS_DASHBOARD_URL = "/targets/v3";